import Paragraph from 'elements/Paragraph';

/* eslint react/destructuring-assignment: "off" */
/* eslint no-confusing-arrow: "off" */

const StyledParagraph = Paragraph.extend`
display: ${props => props.isEmpty ? 'none' : 'block'};
    & p{
        margin: 0 6px 0 0;
    }
`;

export default StyledParagraph;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Paragraph.jsx